import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Navbar from "components/navbar/Navbar";

function App() {

  return (
    <Flex width={"100%"} flexDirection={"column"} justifyContent={"space-between"} minH={"80vh"}>
      <header>
        <Navbar/>
      </header>
      <main>
        <Box className="main-container">
          <Outlet />
        </Box>
      </main>
      <footer>
        <Box className="footer-container" as="footer">
          <small>
            © {new Date().getFullYear()} Università di Padova - Tutti i diritti riservati
          </small>
        </Box>
      </footer>
    </Flex>);
}
export default App;
